import { Box, Card, Grid } from '@mui/material';
import FoodItemCard from 'components/FoodItemCard/FoodItemCard';
import FoodItemCardSkeleton from 'components/FoodItemCard/FoodItemCardSkeleton';
import NoItemsCreated from 'components/NoItemsCreated/NoItemsCreated';
import NoSearchFound from 'components/NoSearchFound/NoSearchFound';
import HeaderTilteBar from 'components/TitleBar/HeaderTilteBar';
import React from 'react'
import MainContainer from 'theme/MainConatiner';

const FoodItemsContainer = ({
    foodItem,
    setSearchQuery,
    searchTxt,
    handleAddBtn,
    loading,
    error,
    handleEdit,
    handleDelete,
    handleToggle,
    togglingCollectionId,
    isCategory,
    onViewAddOns,
    categories,
    selectedCategory,
    onCategoryChange
}) => {
    const PLACEHOLDER_COUNT = 6;
    const hasData = !loading && foodItem?.length > 0;
    const showNoItems = !loading && foodItem?.length == 0;
    const itemsToRender = loading ? Array.from({ length: PLACEHOLDER_COUNT }) : foodItem;
    const isSearching = searchTxt.trim().length > 0

    return (
        <MainContainer>
            <Card className='main-card-container'>
                <HeaderTilteBar
                    title={"Food Items"}
                    isSearch={foodItem?.length > 0 || isSearching}
                    btnText={"Add New"}
                    btnIcon={true}
                    onSearchChange={setSearchQuery}
                    searchQuery={searchTxt}
                    handleAddBtn={handleAddBtn}
                    addDisabled={isCategory}
                    isFilter={true}
                    categories={categories}
                    selectedCategory={selectedCategory}
                    onCategoryChange={onCategoryChange}
                // handleBack={handleBack}
                />

                {showNoItems && (
                    <Box className='body-wrapper'>
                        {isSearching ? (
                            <NoSearchFound
                                title="No Food Item matches your search"
                                subtitle={`Please try again with a different keyword to get result..`}
                            />
                        ) : (
                            <NoItemsCreated
                                title="No Food Items Created Yet!"
                                subtitle="Add your first food item to create your own menu."
                                isWarning={isCategory}
                                warningTxt="Create a Food Category first to be able to add Food Item"
                            />
                        )}
                    </Box>
                )}

                {!showNoItems && (
                    <Box sx={{ mt: 1 }}>
                        <Grid container spacing={2}>
                            {itemsToRender?.map((cat, idx) => (
                                <Grid item xs={12} sm={6} md={3} key={cat?.id ?? idx}>
                                    {loading ? (
                                        <FoodItemCardSkeleton />
                                    ) : (
                                        <FoodItemCard
                                            data={cat}
                                            enabled={cat?.active_status}
                                            onEdit={() => handleEdit(cat)}
                                            onDelete={() => handleDelete(cat)}
                                            onToggle={() => handleToggle(cat)}
                                            toggleDisabled={togglingCollectionId === cat.id}
                                            onViewAddOns={() => onViewAddOns(cat)}
                                        />
                                    )}
                                </Grid>
                            ))}
                        </Grid>
                    </Box>
                )}
            </Card>
        </MainContainer>
    )
}

export default FoodItemsContainer
